import { createReducer, on } from '@ngrx/store';
import * as recaptchActions from '../actions/recaptcha.actions';

export interface State {
  reCaptchaValidated: boolean;
  errorMessage: string;
  message: string;
}

const initialState: State = {
  reCaptchaValidated: false,
  errorMessage: '',
  message: ''
};

export const reducer = createReducer(
  initialState,
  on(recaptchActions.InitializeReCaptcha, (state, action) => ({
    ...state,
    reCaptchaValidated: false,
  })),
  on(recaptchActions.ValidatedReCaptcha, (state, action) => {
    console.log('reducer', action.success);
    return {
      ...state,
      reCaptchaValidated: action.success,
      errorMessage: '',
    }
  }),
  on(recaptchActions.ValidateReCaptchaError, (state, action) => ({
    ...state,
    errorMessage: action.errorMessage,
  })),
);

